// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"779":"020275fe","908":"d7598ae0"}[chunkId] + ".chunk.css";
};